import { render, staticRenderFns } from "./IconHouse.vue?vue&type=template&id=ea51987a"
import script from "./IconHouse.vue?vue&type=script&lang=js"
export * from "./IconHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports